import PropTypes from "prop-types";
import { Box, IconButton } from "@mui/material";
import { X } from "lucide-react";

/** Image at full size over a dark backdrop; a click outside the image closes it. */
export function ImageLightbox({ url, onClose }) {
  return (
    <Box
      onClick={onClose}
      sx={{
        position: "fixed",
        inset: 0,
        backgroundColor: "rgba(0, 0, 0, 0.8)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 1500,
        cursor: "pointer",
      }}
    >
      <Box onClick={(event) => event.stopPropagation()} sx={{ position: "relative", maxWidth: "90vw", maxHeight: "90vh" }}>
        <Box
          component="img"
          src={url}
          alt="Previsualización ampliada"
          sx={{
            maxWidth: "90vw",
            maxHeight: "85vh",
            width: "auto",
            height: "auto",
            objectFit: "contain",
            borderRadius: "12px",
            display: "block",
          }}
        />
        <IconButton
          aria-label="Cerrar"
          onClick={onClose}
          sx={{
            position: "absolute",
            top: 8,
            right: 8,
            color: "#fff",
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            "&:hover": { backgroundColor: "rgba(0, 0, 0, 0.7)" },
          }}
        >
          <X size={22} />
        </IconButton>
      </Box>
    </Box>
  );
}

ImageLightbox.propTypes = {
  url: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
};
